import { API } from "aws-amplify";

class AirportsService {
  airportsSave = (airList) => {
    const tmpAir = airList.map((item) => {
      return {
        value: item.airportCode,
        label: item.airportName,
        isDisabled: !item.isActive,
        countryCode: item.countryCode
      };
    });
    sessionStorage.setItem("aitports-list", JSON.stringify(tmpAir));
    return tmpAir;
  };

  getAirportsFromStorage = () => {
    const data = sessionStorage.getItem("aitports-list");
    if (data) {
      return JSON.parse(data);
    }
    return null;
  };

  getAirportsOptions(){
    const localAir = this.getAirportsFromStorage();
    if (localAir) {
      return new Promise((res, rej)=> {
        res(localAir);
        rej([])
        }) ;
    } else {
      return API.get("IAPI", "Airports/airports/")
        .then((res) => {
          res = this.airportsSave(res);
          return res;
        })
        .catch((error) => {
          return [];
        });
    }
  }

  getAirports = async () => {
    var ReturnObj = [];
    await API.get('IAPI', 'Airports/airports/')
       .then((res) => {
          ReturnObj = res;
          return res;
       }).catch((error) => {
          return error;
       }
       );
    return ReturnObj;
 }

}

export default new AirportsService();
